// import React, { useEffect, useMemo, useState } from "react";
// import {
//   NavLink as NavLinkRRD,
//   Link,
//   matchPath,
//   useLocation,
// } from "react-router-dom";
// import PropTypes from "prop-types";
// import { useAuth } from "../../auth/AuthContext";
// import {
//   Collapse,
//   NavbarBrand,
//   Navbar,
//   NavItem,
//   NavLink,
//   Nav,
//   Container,
// } from "reactstrap";
// import { ReactComponent as MaximizeIcon } from "../../assets/icons/maximize-square-minimalistic-svgrepo-com.svg";
// import SidebarFlyout from "./SidebarFlyout";

// const LG_MIN = 992; // จุดเริ่ม "หน้าจอกลาง"
// const XL_MIN = 1370; // จุดเริ่ม "หน้าจอใหญ่"

// const Sidebar = (props) => {
//   // ===== Helper =====
//   const renderIcon = (icon) => {
//     if (!icon) return null;
//     if (typeof icon === "string") return <i className={icon} />;
//     if (React.isValidElement(icon))
//       return React.cloneElement(icon, { className: "nav-icon" });
//     if (typeof icon === "function") {
//       const C = icon;
//       return <C className="nav-icon" />;
//     }
//     return null;
//   };

//   // ===== Auth / Role =====
//   const { user } = useAuth();
//   const role = user?.role?.toLowerCase() === "admin" ? "admin" : "user";
//   const canSee = (item) =>
//     !item.hidden && (!item.roles || (role && item.roles.includes(role)));

//   // ===== State =====
//   const location = useLocation();
//   const [openMenus, setOpenMenus] = useState({});
//   const [hoverGroup, setHoverGroup] = useState(null);
//   const [anchorRect, setAnchorRect] = useState(null);
//   const sidebarMiniWidth = 72;

//   // ✅ FIX: เช็ค active แบบ "ตรง path จริง" (ไม่ใช้ startsWith)
//   const isActiveExact = (path) =>
//     !!matchPath({ path, end: true }, location.pathname);

//   // เริ่มต้น isMini: ถ้าอยู่ช่วงหน้าจอกลาง -> mini เสมอ, ถ้าจอใหญ่ -> ตาม localStorage
//   const initMini = () => {
//     const saved = localStorage.getItem("sidebar_mini") === "1";
//     const w = typeof window !== "undefined" ? window.innerWidth : XL_MIN;
//     if (w >= LG_MIN && w < XL_MIN) return true;
//     return saved;
//   };
//   const [isMini, setIsMini] = useState(initMini);

//   // ===== Class toggle =====
//   useEffect(() => {
//     document.body.classList.toggle("sidebar-mini", isMini);
//     if (!isMini) setHoverGroup(null);
//   }, [isMini]);

//   // ปรับ isMini อัตโนมัติเมื่อ resize เข้าสู่/ออกจากช่วงหน้าจอกลาง
//   useEffect(() => {
//     const handle = () => {
//       const w = window.innerWidth;
//       if (w >= LG_MIN && w < XL_MIN) {
//         // ช่วงหน้าจอกลาง: บังคับ mini เสมอ (ไม่แตะ localStorage)
//         setIsMini(true);
//       } else if (w >= XL_MIN) {
//         // จอใหญ่: เคารพค่าที่ผู้ใช้บันทึกไว้
//         const saved = localStorage.getItem("sidebar_mini") === "1";
//         setIsMini(saved);
//       } else {
//         // <992: โหมดมือถือ (ซ่อนด้วย CSS/เลย์เอาท์อยู่แล้ว) — ไม่ยุ่งสถานะ mini
//       }
//     };
//     window.addEventListener("resize", handle);
//     handle(); // run once on mount
//     return () => window.removeEventListener("resize", handle);
//   }, []);

//   // ปิด flyout เมื่อเปลี่ยนหน้า
//   useEffect(() => setHoverGroup(null), [location.pathname]);

//   // ===== Toggle mini mode (ผู้ใช้กดปุ่ม) =====
//   const toggleMini = () => {
//     setIsMini((v) => {
//       const nv = !v;
//       localStorage.setItem("sidebar_mini", nv ? "1" : "0");
//       return nv;
//     });
//   };

//   // ===== Toggle mini จาก navbar (ผ่าน window event) =====
//   useEffect(() => {
//     const handler = () => {
//       toggleMini();
//     };

//     window.addEventListener("app:toggleSidebarMini", handler);
//     return () => window.removeEventListener("app:toggleSidebarMini", handler);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // ===== เปิดเมนูย่อยแบบคลิกเมื่อเป็น mini =====
//   const handleGroupToggle = (key, el) => {
//     if (!isMini || !el) return;
//     const rect = el.getBoundingClientRect();
//     setAnchorRect(rect);
//     setHoverGroup((curr) => (curr === key ? null : key));
//   };

//   // ===== Create links =====
//   const createLinks = () => {
//     const visible = (items) => items.filter(canSee);

//     return visible(props.routes).map((prop, key) => {
//       if (prop.children?.length) {
//         const children = visible(prop.children);
//         if (!children.length) return null;

//         // ✅ FIX: active group จาก child แบบ exact เท่านั้น
//         const anyChildActive = children.some((c) => isActiveExact(c.path));

//         return (
//           <NavItem key={`grp-${key}`} className="mb-0">
//             <a
//               href="#!"
//               onClick={(e) => {
//                 e.preventDefault();
//                 if (isMini) {
//                   handleGroupToggle(key, e.currentTarget);
//                 } else {
//                   setOpenMenus((s) => ({ ...s, [key]: !s[key] }));
//                 }
//               }}
//               className={`nav-link d-flex align-items-center ${
//                 anyChildActive ? "active" : ""
//               }`}
//               title={isMini ? prop.name : undefined}
//             >
//               {renderIcon(prop.icon)}
//               <span className="nav-text pl-3" style={{ fontWeight: 600 }}>
//                 {prop.name}
//               </span>
//               {!isMini && (
//                 <i
//                   className={`ml-auto ni ${
//                     openMenus[key] ? "ni-bold-down" : "ni-bold-right"
//                   }`}
//                 />
//               )}
//             </a>

//             {/* ปกติ (ไม่ mini): แสดง Collapse */}
//             {!isMini && (
//               <Collapse isOpen={!!openMenus[key]}>
//                 <Nav className="nav-sm flex-column mt-0">
//                   {children.map((child, idx) => (
//                     <NavItem key={`child-${key}-${idx}`}>
//                       <NavLink
//                         to={child.path}
//                         tag={NavLinkRRD}
//                         // ✅ FIX: child active แบบ exact
//                         className={isActiveExact(child.path) ? "active" : ""}
//                       >
//                         <span className="nav-text pl-3">{child.name}</span>
//                       </NavLink>
//                     </NavItem>
//                   ))}
//                 </Nav>
//               </Collapse>
//             )}

//             {/* mini: ใช้ flyout */}
//             {isMini && hoverGroup === key && (
//               <SidebarFlyout
//                 items={children.map((c) => ({ name: c.name, path: c.path }))}
//                 anchorRect={anchorRect}
//                 sidebarWidth={sidebarMiniWidth}
//                 onClose={() => setHoverGroup(null)}
//               />
//             )}
//           </NavItem>
//         );
//       }

//       return (
//         <NavItem key={key}>
//           <NavLink
//             to={prop.path}
//             tag={NavLinkRRD}
//             // ✅ FIX: leaf active แบบ exact
//             className={`nav-link nav-leaf d-flex align-items-center ${
//               isActiveExact(prop.path) ? "active" : ""
//             }`}
//             title={isMini ? prop.name : undefined}
//             onClick={() => setHoverGroup(null)}
//           >
//             {renderIcon(prop.icon)}
//             <span className="nav-text pl-3" style={{ fontWeight: 600 }}>
//               {prop.name}
//             </span>
//           </NavLink>
//         </NavItem>
//       );
//     });
//   };

//   // ===== Logo =====
//   const { logo } = props;
//   const navbarBrandProps = logo?.innerLink
//     ? { to: logo.innerLink, tag: Link }
//     : logo?.outterLink
//     ? { href: logo.outterLink, target: "_blank" }
//     : {};

//   // ===== Render =====
//   return (
//     <Navbar
//       className={`navbar-vertical fixed-left navbar-light bg-white ${
//         isMini ? "sidebar-mini" : ""
//       }`}
//       expand="md"
//       id="sidenav-main"
//     >
//       <Container fluid>
//         <div className="sidebar-header px-3 py-1">
//           {logo && (
//             <NavbarBrand
//               className="pt-0 brand-wrap mx-auto"
//               {...navbarBrandProps}
//             >
//               <img
//                 alt={logo.imgAlt}
//                 className="navbar-brand-img"
//                 src={logo.imgSrc}
//                 style={{
//                   height: 45,
//                   width: "auto",
//                   transition: "all 0.25s ease",
//                   display: "block",
//                   margin: "0 auto",
//                 }}
//               />
//             </NavbarBrand>
//           )}
//         </div>

//         <Collapse navbar isOpen>
//           <Nav navbar className="mt-0">
//             {createLinks()}
//           </Nav>
//         </Collapse>
//       </Container>
//     </Navbar>
//   );
// };

// // ===== PropTypes =====
// Sidebar.defaultProps = { routes: [{}] };
// Sidebar.propTypes = {
//   routes: PropTypes.arrayOf(PropTypes.object),
//   logo: PropTypes.shape({
//     innerLink: PropTypes.string,
//     outterLink: PropTypes.string,
//     imgSrc: PropTypes.string.isRequired,
//     imgAlt: PropTypes.string.isRequired,
//   }),
// };

// export default Sidebar;

import React, { useEffect, useState } from "react";
import {
  NavLink as NavLinkRRD,
  Link,
  matchPath,
  useLocation,
} from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "../../auth/AuthContext";
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from "reactstrap";
import SidebarFlyout from "./SidebarFlyout";

const Sidebar = (props) => {
  // ===== Auth / Role =====
  const { user } = useAuth();
  const role = user?.role?.toLowerCase() === "admin" ? "admin" : "user";
  const canSee = (item) =>
    !item.hidden && (!item.roles || (role && item.roles.includes(role)));

  // ===== State / Location =====
  const location = useLocation();

  const [hoverGroup, setHoverGroup] = useState(null);
  const [anchorRect, setAnchorRect] = useState(null);
  const sidebarMiniWidth = 72;

  // 🔒 mini ตลอดเวลา
  const isMini = true;

  // ===== Active check (exact only) =====
  const isActiveExact = (path) =>
    !!matchPath({ path, end: true }, location.pathname);

  // ===== Force body class =====
  useEffect(() => {
    document.body.classList.add("sidebar-mini");
    localStorage.setItem("sidebar_mini", "1");
    return () => {
      // optional: ถ้าอยากล้างตอน unmount
      // document.body.classList.remove("sidebar-mini");
    };
  }, []);

  // ปิด flyout เมื่อเปลี่ยนหน้า
  useEffect(() => {
    setHoverGroup(null);
  }, [location.pathname]);

  // ✅ ไม่โชว์ sidebar เฉพาะหน้า index (ทำหลัง hooks)
  const HIDE_SIDEBAR_PATHS = ["/index", "/submenu-product-service"];
  const shouldHideSidebar = HIDE_SIDEBAR_PATHS.includes(location.pathname);
  if (shouldHideSidebar) return null;

  // ===== Helper =====
  const renderIcon = (icon) => {
    if (!icon) return null;
    if (typeof icon === "string") return <i className={icon} />;
    if (React.isValidElement(icon))
      return React.cloneElement(icon, { className: "nav-icon" });
    if (typeof icon === "function") {
      const C = icon;
      return <C className="nav-icon" />;
    }
    return null;
  };

  // ===== Open flyout =====
  const handleGroupToggle = (key, el) => {
    if (!el) return;
    const rect = el.getBoundingClientRect();
    setAnchorRect(rect);
    setHoverGroup((curr) => (curr === key ? null : key));
  };

  // ===== Create links =====
  const createLinks = () => {
    const visible = (items) => items.filter(canSee);

    return visible(props.routes).map((prop, key) => {
      if (prop.children?.length) {
        const children = visible(prop.children);
        if (!children.length) return null;

        const anyChildActive = children.some((c) => isActiveExact(c.path));

        return (
          <NavItem key={`grp-${key}`} className="mb-0">
            <a
              href="#!"
              onClick={(e) => {
                e.preventDefault();
                handleGroupToggle(key, e.currentTarget);
              }}
              className={`nav-link d-flex align-items-center ${
                anyChildActive ? "active" : ""
              }`}
              title={prop.name}
            >
              {renderIcon(prop.icon)}
            </a>

            {isMini && hoverGroup === key && (
              <SidebarFlyout
                items={children.map((c) => ({ name: c.name, path: c.path }))}
                anchorRect={anchorRect}
                sidebarWidth={sidebarMiniWidth}
                onClose={() => setHoverGroup(null)}
              />
            )}
          </NavItem>
        );
      }

      return (
        <NavItem key={key}>
          <NavLink
            to={prop.path}
            tag={NavLinkRRD}
            className={`nav-link nav-leaf d-flex align-items-center ${
              isActiveExact(prop.path) ? "active" : ""
            }`}
            title={prop.name}
            onClick={() => setHoverGroup(null)}
          >
            {renderIcon(prop.icon)}
          </NavLink>
        </NavItem>
      );
    });
  };

  // ===== Logo =====
  const { logo } = props;
  const navbarBrandProps = logo?.innerLink
    ? { to: logo.innerLink, tag: Link }
    : logo?.outterLink
      ? { href: logo.outterLink, target: "_blank" }
      : {};

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white sidebar-mini"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* <div className="sidebar-header px-3 py-1">
          {logo && (
            <NavbarBrand className="pt-0 brand-wrap mx-auto" {...navbarBrandProps}>
              <img
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={logo.imgSrc}
                style={{ height: 40, width: "auto", display: "block", margin: "0 auto" }}
              />
            </NavbarBrand>
          )}
        </div> */}

        <Collapse navbar isOpen>
          <Nav navbar className="mt-0">
            {createLinks()}
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

// ===== PropTypes =====
Sidebar.defaultProps = { routes: [{}] };
Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
